import { useState, useEffect, useCallback } from "react";
import { fetchConfigList } from "../api/apiClient";
import { useActiveTenant } from "./useActiveTenant";

/**
 * Tenant-configurable dropdown values (course category, skill category,
 * teaching role) — replaces what used to be hardcoded arrays. Falls back to
 * `fallback` while loading or if the tenant has no items configured for
 * `listKey` yet.
 */
export function useConfigList(listKey, fallback = []) {
  const { tenantId } = useActiveTenant();
  const [values, setValues] = useState(fallback);

  const reload = useCallback(() => {
    if (!tenantId) return;
    fetchConfigList(tenantId, listKey)
      .then((items) => setValues(items.length ? items.map((i) => i.value) : fallback))
      .catch(() => setValues(fallback));
    // `fallback` defaults to a new array each render; including it would refetch on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, listKey]);

  useEffect(() => {
    reload();
  }, [reload]);

  return values;
}
